import script from "./TransactionDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetailDrawer.vue?vue&type=style&index=0&id=393958bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393958bc"]])

export default __exports__